import axios from "axios";

const state = {
  processing: false,
  text: ""
};

const getters = {
  state: state => state
};

const actions = {};

const mutations = {
  PROCESSING(state, text) {
    state.processing = true;
    state.text = text;
    setTimeout(() => state.processing = false, 30000)
  },
  PROCESSED(state) {
    state.processing = false;
    state.text = "";
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
